import PropTypes, { object } from "prop-types";
import WalletTransactionList from "./WalletTransactionList/WalletTransactionList";
import classes from "./WalletTransactions.module.css";
import DateView from "../../DateView/DateView";

const WalletTransactions = (props) => {
  const { transactions } = props;
  return (
    <ul className={classes["wallet-transactions"]}>
      {transactions.map((transaction, index) => (
        <li key={index} className={classes["wallet-transactions__list-item"]}>
          <div className={classes["wallet-transactions__date-wrapper"]}>
            <DateView date={transaction.createdAt} />
          </div>
          <WalletTransactionList transactions={transaction.transactionList} />
        </li>
      ))}
    </ul>
  );
};

export default WalletTransactions;

WalletTransactions.propTypes = {
  transactions: PropTypes.arrayOf(object),
};
